export default __webpack_public_path__ + "static/media/createPage.acdb2ad7.png";